import { gql } from '@apollo/client';

export const GET_LIGHTBOX_DATA = gql`
  query fetchData($endPoint:String,$params:JSON) {
    fetchData(endPoint:$endPoint,params:$params) {
      success
      message
      error
      data
    }
  }
`;